(() => {
  if (window.TDFWCollectionScroll || !('IntersectionObserver' in window)) return;
  window.TDFWCollectionScroll = true;
  const states = new Map();
  function init() {
    for (const [grid, state] of states) {
      if (!grid.isConnected) { state.observer.disconnect(); state.controller?.abort(); states.delete(grid); }
    }
    document.querySelectorAll('[data-scroll-products]').forEach(grid => {
      if (states.has(grid)) return;
      const section = grid.closest('[data-section-id]');
      const pager = section?.querySelector('[data-scroll-pagination]');
      if (!pager || !pager.dataset.nextUrl) return;
      const fallback = pager.querySelector('.pagination');
      const status = pager.querySelector('[data-scroll-status]');
      const state = { busy: false, observer: null, controller: null };
      async function load() {
        if (state.busy || !grid.isConnected || !pager.dataset.nextUrl) return;
        state.busy = true;
        state.observer.unobserve(pager);
        state.controller = new AbortController();
        grid.setAttribute('aria-busy', 'true');
        if (status) status.setAttribute('data-loading', 'true');
        const nextUrl = new URL(pager.dataset.nextUrl, location.origin);
        try {
          if (nextUrl.origin !== location.origin) throw new Error('Unexpected page origin');
          const requestUrl = new URL(nextUrl.href);
          requestUrl.searchParams.set('section_id', section.dataset.sectionId);
          const response = await fetch(requestUrl.href, { credentials: 'same-origin', signal: state.controller.signal });
          if (!response.ok) throw new Error('Unable to load next page');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!grid.isConnected) return;
          const newSection = Array.from(page.querySelectorAll('[data-section-id]')).find(el => el.dataset.sectionId === section.dataset.sectionId);
          const newGrid = newSection?.querySelector('[data-scroll-products]');
          if (!newGrid) throw new Error('Product grid missing');
          const newPager = newSection.querySelector('[data-scroll-pagination]');
          const newNext = newPager?.dataset.nextUrl || '';
          if (newNext && new URL(newNext, location.origin).href === nextUrl.href) throw new Error('Repeated page');
          grid.append(...Array.from(newGrid.children));
          pager.dataset.nextUrl = newNext;
          if (fallback && newPager) fallback.innerHTML = newPager.querySelector('.pagination')?.innerHTML || '';
          if (window.TDFWWishlist) window.TDFWWishlist.refresh();
          if (newNext) state.observer.observe(pager);
          else pager.hidden = true;
        } catch (error) {
          if (error.name !== 'AbortError' && grid.isConnected) {
            if (fallback) fallback.hidden = false;
            if (status) status.hidden = true;
            console.warn('Collection scroll: use pagination to continue.', error);
          }
        } finally {
          state.busy = false;
          if (status) status.removeAttribute('data-loading');
          if (grid.isConnected) grid.removeAttribute('aria-busy');
        }
      }
      state.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) load();
      }, { rootMargin: '300px 0px' });
      states.set(grid, state);
      if (fallback) fallback.hidden = true;
      if (status) status.hidden = false;
      state.observer.observe(pager);
    });
  }
  document.addEventListener('filters-applied', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => setTimeout(init, 0));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();